import { AxiosError } from 'axios';
import { atomWithQuery } from 'jotai-tanstack-query';
import { instance } from '..';
import { Order } from '@/types/plan';

export const planOrderListAtom = atomWithQuery<Order[], AxiosError, any, [string]>((get) => ({
  queryKey: ['ORDER_LIST'],
  queryFn: async ({ queryKey: [] }) => {
    const temp = await planOrderList();
    if (temp && temp.data) {
      return temp.data.data;
    }
  },
}));

const planOrderList = async () => {
  return await instance.get('/api_shipping_v2/orders', { params: { order_state: 'Open' } });
};

export const getOrderList = async () => {
  return await instance.get('/api_shipping_v2/order_info/96/145');
};
